module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "background",
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "id": (_vm.videoPlayerId + "-bgVideo-container")
    }
  }, [_c('div', {
    staticClass: "background",
    attrs: {
      "id": (_vm.videoPlayerId + "-videoPlayerBackground")
    }
  }), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.masterInUse),
      expression: "masterInUse"
    }],
    key: (_vm.videoPlayerId + "-master"),
    staticClass: "background transitionItem",
    class: {
      'blur-filter': _vm.isBlur
    },
    staticStyle: {
      "cursor": "default",
      "z-index": "200"
    },
    attrs: {
      "id": (_vm.videoPlayerId + "-master"),
      "type": "video/mp4",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "timeupdate": _vm.videoTimeUpdateEventHandler,
      "playing": _vm.videoStartedEventHandler,
      "ended": _vm.videoEndedEventHandler
    }
  }, [_vm._v("\n      Your browser does not support the video tag.\n    ")]), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.masterInUse),
      expression: "!masterInUse"
    }],
    key: (_vm.videoPlayerId + "-slave"),
    staticClass: "background transitionItem",
    class: {
      'blur-filter': _vm.isBlur
    },
    staticStyle: {
      "cursor": "default",
      "z-index": "150"
    },
    attrs: {
      "id": (_vm.videoPlayerId + "-slave"),
      "type": "video/mp4",
      "muted": "",
      "playsinline": "",
      "webkit-playsinline": ""
    },
    domProps: {
      "muted": true
    },
    on: {
      "timeupdate": _vm.videoTimeUpdateEventHandler,
      "playing": _vm.videoStartedEventHandler,
      "ended": _vm.videoEndedEventHandler
    }
  }, [_vm._v("\n      Your browser does not support the video tag.\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-707738e7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Background-Video-Player.vue
// module id = 229
// module chunks = 1